/**
 * Static page slugs that are handled by the /static_page route
 * These pages use the StaticPages component and are rendered via pages/static_page.page.tsx
 */
export const STATIC_PAGE_SLUGS = [
	'activate-account',
	'cancellation-and-price-adjustments',
	'code-of-conduct',
	'contact-us',
	'cookies',
	'payment-terms',
	'payments-assurance-policy',
	'privacy',
	'terms',
] as const;

export type StaticPageSlug = (typeof STATIC_PAGE_SLUGS)[number];

/**
 * Check if a given slug should use the /static_page href
 */
export const isStaticPageSlug = (slug: string): slug is StaticPageSlug => {
	return STATIC_PAGE_SLUGS.includes(slug as StaticPageSlug);
};

/**
 * Check if a given path should use the /static_page href
 * Handles paths with leading slash like "/contact-us"
 */
export const shouldUseStaticPageHref = (path: string): boolean => {
	const slug = path.startsWith('/') ? path.slice(1) : path;
	return isStaticPageSlug(slug);
};
